"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var getColorClass = function (badgeColor) {
    if (badgeColor === "red")
        return "bg-red-100 dark:bg-red-600 text-red-800 dark:text-red-100";
    if (badgeColor === "yellow")
        return "bg-yellow-100 dark:bg-yellow-600 text-yellow-800 dark:text-yellow-100";
    if (badgeColor === "green")
        return "bg-green-100 dark:bg-green-600 text-green-800 dark:text-green-100";
    if (badgeColor === "cyan")
        return "bg-cyan-100 dark:bg-cyan-600 text-cyan-800 dark:text-cyan-100";
    if (badgeColor === "teal")
        return "bg-teal-100 dark:bg-teal-600 text-teal-800 dark:text-teal-100";
    if (badgeColor === "blue")
        return "bg-blue-100 dark:bg-blue-600 text-blue-800 dark:text-blue-100";
    if (badgeColor === "indigo")
        return "bg-indigo-100 dark:bg-indigo-600 text-indigo-800 dark:text-indigo-100";
    if (badgeColor === "purple")
        return "bg-purple-100 dark:bg-purple-600 text-purple-800 dark:text-purple-100";
    if (badgeColor === "rose")
        return "bg-rose-100 dark:bg-rose-600 text-rose-800 dark:text-rose-100";
    return "bg-gray-100 dark:bg-gray-600 text-gray-800 dark:text-gray-100";
};
var Label = function (props) {
    var name = props.name, color = props.color;
    return (preact_1.h("span", { className: getColorClass(color) + " inline-flex items-center px-2 py-0.5 rounded-full text-[0.65rem] flex-shrink-0 font-medium hover:no-underline transition mb-0.5 mr-0.5" }, name));
};
exports.default = Label;
